<template>

  <v-container fluid class="px-0 order-info-attachment-docs">

    <!-- Order Attachment Docs -->
    <order-attachment-documents class="page-content" :order="order" />

  </v-container>

</template>

<script>
import OrderAttachmentDocuments from '@/components/orders/OrderAttachmentDocuments'

export default {
  name: 'OrderInfoAttachmentDocuments',

  components: {
    OrderAttachmentDocuments
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  computed: {
    order () {
      return this.$parent.order
    }
  },

  methods: {
    async reloadOrderData () {
      return this.$parent.reloadOrderData()
    }
  }
}
</script>

<style>
</style>
